// import React, {
//   Fragment,
//   useState,
//   useRef,
//   useEffect,
//   useContext,
// } from "react";
// import { Link } from "react-router-dom";
// import cx from "classnames";
// import { Helmet } from "react-helmet";
// import { AppContext } from "../../components/AppProvider";
// import { _API, _CK, _U } from "../../modules/utils";
// import { DynamicStyles } from "../../components/GlobalStyles";
// import styled from "styled-components";
// import Paging from '../../components/pagination/pagination';

// import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
// import { Swiper, SwiperSlide } from "swiper/react";

// import "swiper/swiper.scss";
// import "swiper/components/navigation/navigation.scss";
// import "swiper/components/pagination/pagination.scss";
// import "swiper/components/scrollbar/scrollbar.scss";
// SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

// import "../../resources/question/modal.css";
// import "../../resources/question/fms.css";
// import "../../resources/preReg/styles.css";

// import { _CFG } from "../../modules/config";
// import Layout, {
//   Wrapper,
//   HiddenWrapper,
// } from "../../components/UI/preReg/Layout";
// import moment from "moment";

// import { SideBarTypes } from "../../components/UI/preReg/Layout.Sidebar";
// import NoneImg from "../../resources/console/images/icon/noneimg.png";
// import icon_search from "../../resources/preReg/images/icon/icon_search.svg";
// import btn_sessionmore from "../../resources/preReg/images/icon/btn_sessionmore.svg";
// import prevbtn from "../../resources/preReg/images/icon/prevbtn.svg";
// import prevUpperbtn from "../../resources/preReg/images/icon/prevUpperbtn.svg";
// import nextbtn from "../../resources/preReg/images/icon/nextbtn.svg";
// import nextUpperbtn from "../../resources/preReg/images/icon/nextUpperbtn.svg";
// import icon_moredrop from "../../resources/preReg/images/icon/icon_moredrop.svg";
// import icon_search_cancel from "../../resources/preReg/images/icon/icon_search_cancel.svg";
// import icon_search_delete from "../../resources/preReg/images/icon/icon_search_delete.svg";
// import icon_sortup from "../../resources/preReg/images/icon/icon_sortup.svg";
// import icon_sortdown from "../../resources/preReg/images/icon/icon_sortdown.svg";

// import icon_close from "../../resources/images/fms/icon_close.svg";
// import { orderBy } from "lodash";
// import MemberForm from "../../components/member/Member.Form";

// export default (props) => {
//   const { auth, cfg, iam } = useContext(AppContext);
//   const { saveAuth, saveIam } = useContext(AppContext);

//   const { history, match } = props;
//   // 사이트 정보
//   const [siteInfo, setSiteInfo] = useState(cfg);

//   // 이벤트 정보
//   const [eventInfo, setEventInfo] = useState({});

//   const [loaded, setLoaded] = useState(false);

//   const [info, setInfo] = useState({});

//   //참가IDX
//   // const [attendIdx, setAttendIdx] = useState("");

//   const eventIdx = match?.params.eventIdx;
//   /**
//    * 화면 초기화
//    *
//    * initPage()
//    *  - gsap (애니메이션 초기화)
//    *  - 모달 버튼 클릭 이벤트
//    */
//   useEffect(() => {
//     // !info?.name && setInfo(iam);
//   }, []);

//   return (
//     <Fragment>
//         <Layout>
//           <Wrapper>
//             <QuestionStorageForm eventIdx={eventIdx} />
//           </Wrapper>
//         </Layout>
//       <DynamicStyles />
//     </Fragment>
//   );
// };

// const QuestionStorageForm = (props) => {
//   const { eventIdx } = props;
//   const { auth, cfg, iam } = useContext(AppContext);
//   const { saveAuth, saveIam } = useContext(AppContext);
//   const [info, setInfo] = useState({});
//   const [view, setView] = useState(false);
//   const [mview, setMview] = useState(false);
//   const [isOpen, setOpen] = useState(false);
//   const [text, setText] = useState("");

//   const [isMy, setIsMy] = useState(false);
//   const [questionStatus, setQuestionStatus] = useState("");
//   const [list, setList] = useState([]);
//   const [paging, setPaging] = useState(null);
//   const [idx, setIdx] = useState(null);

//   const [editQuestion, setEditQuestion] = useState({});
//   const [showEditModal, setShowEditModal] = useState(false);

//   const [memberFormModalShow, setMemberFormModalShow] = useState(false);
//   const [memberIdx, setMemberIdx] = useState(null);
//   const [loadCnt, setLoadCnt] = useState(1);
//   const [tabMenu, setTabMenu] = useState(null);

//   useEffect(() => {
//     loadList(1);
//   }, []);

//   const onEdit = (question) => {
//     setEditQuestion(question);
//     setShowEditModal(true);
//   };

//   const removeStorage = (storageIdx) => {
//     const req = {
//       path: "/v1/question/storage/remove",
//       data: {
//         storageIdx,
//       },
//     };
//     _API.post(req).then((res) => {
//       loadList(page.pageNo);
//     });
//   };

//   const loadList = (page, orderBy) => {
//     const req = {
//       path: "/v1/question/storage/list",
//       data: {
//         isMy,
//         eventIdx,
//         code: questionStatus,
//         keyword: text,
//         fmsAuthYn: iam?.fmsAuthYn,
//         page: page || 1,
//         numPerPage: 20,
//         pagePerBlock: 5,
//         orderBy,
//         preregIdx: iam?.preregIdx,
//       },
//     };
//     _API.post(req).then((res) => {
//       const { paging, list } = res.data;

//       setList(list);

//       const pagingItems = [];

//       if (paging) {
//         for (let i = paging.startPageNo; i <= paging.endPageNo; i++) {
//           pagingItems.push(i);
//         }
//       }
//       paging.pagingItems = pagingItems;

//       setPaging(paging);
//     });
    
//   };
//   const onSearch = () => {
//     loadList(1);
//   };
//   const onPageChange = (page) => {
//     loadList(page);
//   };
//   useEffect(() => {
//     loadList(1);
//   }, [questionStatus, isMy]);

//   const moveEventSite = (eventIdx) => {
//     linkEvent(eventIdx);
//   };

//   const linkEvent = (idx) => {
//     if (!idx) {
//       return;
//     }
//     const req = {
//       path: "/v1/question/storage/sitedomain",
//       data: { idx },
//     };
//     _API.post(req).then((res) => {
//       const { domain } = res.data;
//       const port = window.location.hostname === "localhost" ? ":3001" : "";

//       window.open(`http://${domain}${port}/#/event/${idx}/register`, "_blank");
//     });
//   };

//   const onClickQuestionStatus = (code) => {
//     setQuestionStatus(code);
//   };
//   const onClickIsMy = (code) => {
//     setIsMy(code);
//   };

//   const onKeyPressKeyword = (e) => {
//     if (e.key === "Enter") {
//       onSearch();
//     }
//   };

//   const onChangeKeyword = (e) => {
//     setText(e.target.value);
//   };

//   const onReset = () => {
//     setText("");
//   };

//   const orderBy = (code) => {
//     loadList(1, code);
//   };

//   const onClickName = (idx) => {
//     setTabMenu("1");
//     setMemberIdx(idx);
//     setLoadCnt(loadCnt + 1);
//     changeMemberFormModalShow(true);
//   };

//   const changeMemberFormModalShow = (show) => {
//     if (!show) {
//       $("#formModal").modal("hide");
//       loadList(1);
//     }
//     setMemberFormModalShow(show);
//     if (show)
//       setTimeout(() => {
//         $("#formModal").modal("show");
//       }, 10);
//     setLoadCnt(loadCnt + 1);
//   };

//   const changeBrandAddListModalShow = (show) => {
//     if (!show) {
//       $("#brandListModal").modal("hide");
//     }
//     setBrandAddListModalShow(show);
//     if (show)
//       setTimeout(() => {
//         $("#brandListModal").modal("show");
//       }, 10);
//     setLoadCnt(loadCnt + 1);
//   };

//   return (
//     <Fragment>
//       <div className="mypage_header_bnr"></div>
//       <div className="mypage_tab_menu_wrapper">
//         <div className="mypage_tab_menu">
//           <h2>마이페이지</h2>
//           <div className="mypage_tab">
//             <Swiper
//               spaceBetween={0}
//               slidesPerView={"auto"}
//               className="mypage_list"
//             >
//               <SwiperSlide>
//                 <Link to="/mypage" className="link">
//                   개인정보
//                 </Link>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <Link to="/invitation" className="link">
//                   초대장
//                 </Link>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <Link to="/join/symposium" className="link">
//                   참가{cfg?.eventLabel || `심포지엄`}
//                 </Link>
//               </SwiperSlide>
//               <SwiperSlide className="active">
//                 <Link to="/question/storage" className="link">
//                   질문보관함
//                 </Link>
//               </SwiperSlide>
//             </Swiper>
//           </div>
//         </div>
//       </div>

//       <div className="storage_wrap">
//         <div className="storage_wrap_inner">
//           <div className="storage_table_top">
//             <div className="table_select">
//               <button
//                 className="table_btn"
//                 onClick={() => {
//                   setView(!view);
//                 }}
//               >
//                 <h1>질문구분</h1>
//                 <img src={icon_moredrop} />
//               </button>
//               <div className={`table_btn_div ${view ? "active" : ""}`}>
//                 <ul className="table_btn_ul">
//                   <DropboxLi selected={!isMy}>
//                     <a onClick={(e) => onClickIsMy("")}>전체</a>
//                   </DropboxLi>
//                   <DropboxLi selected={isMy === "MY"}>
//                     <a onClick={(e) => onClickIsMy("MY")}>내질문</a>
//                   </DropboxLi>
//                 </ul>
//                 <h2>선별질문</h2>
//                 <ul className="table_btn_ul">
//                   <DropboxLi selected={!questionStatus}>
//                     <a onClick={(e) => onClickQuestionStatus("")}>전체</a>
//                   </DropboxLi>
//                   <DropboxLi selected={questionStatus === "ONLINE"}>
//                     <a onClick={(e) => onClickQuestionStatus("ONLINE")}>
//                       온라인질문
//                     </a>
//                   </DropboxLi>
//                   <DropboxLi selected={questionStatus === "PRE"}>
//                     <a onClick={(e) => onClickQuestionStatus("PRE")}>
//                       사전질문
//                     </a>
//                   </DropboxLi>
//                 </ul>
//               </div>

//               <span>총 {paging?.totalSize}건</span>
//             </div>
//             <div>
//               <input
//                 onChange={onChangeKeyword}
//                 onKeyPress={onKeyPressKeyword}
//                 value={text}
//                 placeholder="질문내용 검색"
//               />
//               {
//                 // TODO css 수정해야 함
//                 (text && (
//                   <img
//                     className="search_del_img"
//                     onClick={onReset}
//                     src={icon_search_delete}
//                   />
//                 )) || <img src={icon_search} onClick={onSearch} />
//               }
//             </div>
//           </div>
//           <table className="question_storage_table">
//             <thead>
//               <tr align="center" height="34">
//                 <th width={100}>번호</th>
//                 <th width={100}>구분</th>
//                 <th width={300}>질문내용</th>
//                 <th width={100}>질문자</th>
//                 <th width={300}>출처</th>
//                 <th width={200}>
//                   보관일시
//                   <span>
//                     <img
//                       onClick={(e) => orderBy("storageRegAsc")}
//                       src={icon_sortup}
//                     />
//                     <img
//                       onClick={(e) => orderBy("storageRegDesc")}
//                       src={icon_sortdown}
//                     />
//                   </span>
//                 </th>
//                 <th width={200}>
//                   제출일시
//                   <span>
//                     <img onClick={(e) => orderBy("regAsc")} src={icon_sortup} />
//                     <img
//                       onClick={(e) => orderBy("regDesc")}
//                       src={icon_sortdown}
//                     />
//                   </span>
//                 </th>
//                 <th width={100}></th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.map((question, index) => (
//                 <tr align="center" key={index}>
//                   <td>{(paging?.virtualRecordNo || 0) - index}</td>
//                   <td>{question?.questionGubun}</td>
//                   <td align="left" style={{ whiteSpace: "pre-wrap" }}>
//                     <div
//                       dangerouslySetInnerHTML={{
//                         __html: (question?.content || "").replace(
//                           /\n/g,
//                           "</br>"
//                         ),
//                       }}
//                     />
//                   </td>
//                   {question?.isSameWriter === "Y" ? (
//                     <td onClick={(e) => onClickName(question?.storageRegId)}>
//                       <a style={{ cursor: "pointer" }}>
//                         {question?.questionName || question?.regNam || ""}
//                       </a>
//                     </td>
//                   ) : (
//                     <td>{question?.questionName || question?.regNam || ""}</td>
//                   )}
//                   <td onClick={(e) => moveEventSite(question?.eventIdx)}>
//                     <a style={{ cursor: "pointer" }}>
//                       {question?.eventName}({question?.sessionName})
//                     </a>
//                   </td>
//                   <td>
//                     {moment(question?.storageRegDate).format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     )}
//                   </td>
//                   <td>
//                     {moment(question?.questionRegDate).format(
//                       "YYYY-MM-DD HH:mm:ss"
//                     )}
//                   </td>
//                   <td>
//                     <MoreButton
//                       question={question}
//                       onEdit={onEdit}
//                       removeStorage={removeStorage}
//                     />
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <Paging paging={paging} loadList={loadList} />
//         </div>
//       </div>
//       {showEditModal && (
//         <Modal>
//           <QuestionEditModal
//             question={editQuestion}
//             closeModal={() => {
//               setShowEditModal(false);
//             }}
//             reload={loadList}
//           />
//         </Modal>
//       )}
//       {memberFormModalShow && (
//         <MemberModal modalId="formModal">
//           <MemberForm
//             idx={memberIdx}
//             // setMember={member}
//             // memType={member.type}
//             loadCnt={loadCnt}
//             setLoadCnt={setLoadCnt}
//             tabMenu={tabMenu}
//             callBack={loadList}
//             changeMemberFormModalShow={changeMemberFormModalShow}
//             changeBrandAddListModalShow={changeBrandAddListModalShow}
//           />
//         </MemberModal>
//       )}

//       <div className="m_question_storage_wrap">
//         <div className="storage_table_top">
//           {isOpen == true ? null : (
//             <div className="table_select">
//               <button
//                 className="table_btn"
//                 onClick={() => {
//                   setView(!view);
//                 }}
//               >
//                 <h1>질문구분</h1>
//                 <img src={icon_moredrop} />
//               </button>
//               <div className={`table_btn_div ${view ? "active" : ""}`}>
//                 <ul className="table_btn_ul">
//                   <li>
//                     <a>전체</a>
//                   </li>
//                   <li>
//                     <a>내질문</a>
//                   </li>
//                 </ul>
//                 <h2>선별질문</h2>
//                 <ul className="table_btn_ul">
//                   <li>
//                     <a>온라인질문</a>
//                   </li>
//                   <li>
//                     <a>사전질문</a>
//                   </li>
//                 </ul>
//               </div>

//               <span>총 4건</span>
//             </div>
//           )}
//           <div>
//             {isOpen == true ? (
//               <>
//                 <img
//                   className="search_cancel_img"
//                   onClick={() => {
//                     setOpen(false);
//                   }}
//                   src={icon_search_cancel}
//                 />
//                 <input
//                   onChange={onChangeKeyword}
//                   onKeyPress={onKeyPressKeyword}
//                   value={text}
//                   placeholder="질문내용 검색"
//                   className={`${isOpen ? "isOpen" : ""}`}
//                 />
//               </>
//             ) : null}
//             {isOpen == true ? (
//               text && (
//                 <img
//                   className="search_del_img"
//                   onClick={onReset}
//                   src={icon_search_delete}
//                 />
//               )
//             ) : (
//               <img
//                 className="search_img"
//                 onClick={() => {
//                   setOpen(true);
//                 }}
//                 src={icon_search}
//               />
//             )}
//           </div>
//         </div>
//         <ul className="m_table_list">
//           <li>
//             <h2>선별질문</h2>
//             <p>
//               성문우선생님 마지막 슬라이드에서 SNP% 변화가 reinfection 의
//               가능성이 희박한데 처음이던 두번째이던 NGS 에러일 수 있지 않나요?
//             </p>
//             <div>
//               <span>김미나</span>
//               <span>이벤트명(세션명)</span>
//             </div>
//             <div>
//               <small>보관 : 2021.09.06 12:36:12</small>
//               <small>제출 : 2021.09.06 12:36:12</small>
//             </div>
//             <div className="table_btn_more">
//               <div>
//                 <img
//                   src={btn_sessionmore}
//                   onClick={() => {
//                     setMview(!mview);
//                   }}
//                 />
//                 <ul className={`table_morebtn ${mview ? "active" : ""}`}>
//                   <li>
//                     <a>수정</a>
//                   </li>
//                   <li>
//                     <a>질문보관함에서 제거</a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </li>
//         </ul>
//       </div>
//     </Fragment>
//   );
// };

// const QuestionEditModal = (props) => {
//   const { closeModal, question, reload } = props;

//   const [questionContent, setQuestionContent] = useState(
//     question?.content || ""
//   );
//   const [questionName, setQuestionName] = useState(
//     question?.questionName || question?.regNam
//   );

//   useEffect(() => {}, [question]);

//   const onCancle = () => {
//     closeModal();
//   };

//   const onSave = () => {
//     const req = {
//       path: "/v1/question/storage/save",
//       data: {
//         idx: question?.storageIdx,
//         content: questionContent,
//         regName: questionName,
//       },
//     };
//     _API.post(req).then((res) => {
//       alert("수정되었습니다.");
//       closeModal();
//       reload(1);
//     });
//   };

//   return (
//     <div className="modalContainer">
//       <div className="modalTitle">
//         <h1>질문</h1>
//         <button
//           onClick={() => {
//             closeModal();
//           }}
//         >
//           <img src={icon_close} />
//         </button>
//       </div>
//       <div className="modalBody modalBody2" style={{ overflow: "auto" }}>
//         <div className="fms_list">
//           <div className="list_edit_top">
//             <h5 className="modal_inner_title">질문내용</h5>
//             <span>{questionContent.length}/500</span>
//             <textarea
//               maxLength={500}
//               value={questionContent || ""}
//               onChange={(e) => setQuestionContent(e.target.value || "")}
//             />
//           </div>
//           <div className="list_edit_mid">
//             <h5 className="modal_inner_title modal_inner_title_writer">
//               작성자
//             </h5>
//             <div className="list_edit_mid_inner">
//               <input
//                 type="text"
//                 value={questionName || ""}
//                 onChange={(e) => setQuestionName(e.target.value || "")}
//               />
//               <input id="author_input" type="checkbox" />
//             </div>
//           </div>
//           <div className="list_edit_btm">
//             <a onClick={onCancle}>취소</a>
//             <button onClick={onSave}>확인</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const MoreButton = (props) => {
//   const { onEdit, removeStorage, question } = props;

//   const [mview, setMview] = useState(false);

//   const onAction = (code) => {
//     setMview(false);
//     if (code === "modify") {
//       onEdit(question);
//     } else {
//       removeStorage(question?.storageIdx);
//     }
//   };

//   return (
//     <div style={{ position: "relative" }}>
//       <img
//         style={{ cursor: "pointer" }}
//         src={btn_sessionmore}
//         onClick={() => {
//           setMview(!mview);
//         }}
//       />
//       <ul
//         className={`table_morebtn ${mview ? "active" : ""}`}
//         style={{ zIndex: 1 }}
//       >
//         <li onClick={(e) => onAction("modify")}>
//           <a>수정</a>
//         </li>
//         <li onClick={(e) => onAction("remove")}>
//           <a>질문보관함에서 제거</a>
//         </li>
//       </ul>
//     </div>
//   );
// };

// const Modal = (props) => {
//   return <div className="modalBackground">{props.children}</div>;
// };

// const MemberModal = (props) => {
//   return (
//     <div
//       className={cx({ modal: true, show: props.show })}
//       id={props.modalId || "modal"}
//       role="dialog"
//       aria-labelledby="modalLabel"
//       aria-hidden="true"
//       data-backdrop="static"
//     >
//       <div className="modal-dialog modal-default">
//         <div className="modal-content">{props.children}</div>
//       </div>
//     </div>
//   );
// };

// const DropboxLi = styled.li`
//   background: ${(props) => (props.selected ? "#e2e2e2" : "")};
// `;

export default () => null;

